// DEPENDENCIES
import React, { Component } from 'react';
import Modal from 'react-modal';
import SVGInline from 'react-svg-inline'

import { connect } from 'react-redux';
import PropTypes from 'prop-types';


// INNER IMPORTS

// utils
import { isEmailValid, isPasswordInvalid, isMobile, isShortMobile} from "../../../utils";

// actions
import { closeTempUserModal, updateTempUser } from '../../../Actions/users';

// svgs
import hackerMugicsSVG from '../../inlineSVGs/hackerMugicsSVG';

// styles
import '../stylesModal.css';
import './TempUserLogin.css';
import closeCrossSVG from "../../inlineSVGs/closeCrossSVG";

class TempUserLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            email: '',
            password: '',
            confirmPassword: ''
        };
    }

    // Every time the user changes the email/password field, the state changes accordingly
    updateEmail(event) {
        this.setState({
            email: event.target.value.toLowerCase()
        })
    }

    updatePassword(event) {
        this.setState({ password: event.target.value }, () => {
            if (this.state.confirmPassword && this.state.password !== this.state.confirmPassword) {

                this.setState({errorMessage: `Passwords don't match`})
            } else {
                this.setState({errorMessage: ''})
            }
        });
    }

    handleConfirmPassword(event) {
        this.setState({ confirmPassword: event.target.value }, () => {
            if (this.state.confirmPassword && this.state.password !== this.state.confirmPassword) {

                this.setState({errorMessage: `Passwords don't match`})
            } else {
                this.setState({errorMessage: ''})
            }
        });
    }

    handleLocalValidation() {
        if (!isEmailValid(this.state.email)) {
            this.setState({ errorMessage: 'Email address is invalid'});
            return false;
        }

        if (this.state.password !== this.state.confirmPassword) {
            this.setState({ errorMessage: 'Passwords don\'t match'});
            return false
        }

        const passCheckStr = isPasswordInvalid(this.state.password);


        if (passCheckStr) {
            this.setState({ errorMessage: passCheckStr });
            return false;
        }

        this.setState({ errorMessage: ''});
        return true;
    }

    handleTakeOver() {
        // let filesWaiting = this.props.filesWaiting;
        if (!this.handleLocalValidation()) return;

        this.props.updateTempUser({ email: this.state.email, password: this.state.password })
            .then(() => {
                this.props.closeTempUserModal();
            })
            .catch(err => {
                if (err && err.response && err.response.data && err.response.data.clientMessage) {
                    this.setState({ errorMessage: err.response.data.clientMessage })
                }
            })
    }

    render() {
        return (
            <div className="temp-user-modal-wrapper">
                <Modal
                    isOpen={this.props.isTempUserModalOpen}
                    className="modal-wrapper temp-user-modal"
                    contentLabel="temp-user-modal"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0)',
                        },
                        content: {
                            height: isMobile() ? window.innerHeight - 30: 450
                        }
                    }}
                >
                    <div onClick={this.props.closeTempUserModal} >
                        <SVGInline className="close-button" svg={closeCrossSVG} component="i"/>
                    </div>
                    <SVGInline className={`mugics-hacker-icon ${isShortMobile() ? 'short-device' : ''}`} svg={hackerMugicsSVG} component="i"/>

                    <div className="content">


                        <div className="title ">Hey there, wanna </div>
                        <div className="title bottom-title">Take over your account?</div>
                        <div className="form-wrapper">
                            <input type="text" id="email" placeholder="New Email" onChange={e => this.updateEmail(e)}/>
                            <input type="password" id="password" placeholder="Choose Password" onChange={e => this.updatePassword(e)}/>
                            <input type="password" id="confirm-password" placeholder="Re-enter Password" onChange={e => this.handleConfirmPassword(e)}/>
                            <div className="error-message">{this.state.errorMessage}</div>
                            <div className="button-wrapper">
                                <button className="button-take-over" onClick={() => this.handleTakeOver()}>Take Over</button>
                            </div>
                            <button className="button-later" onClick={this.props.closeTempUserModal}>Maybe Later</button>
                        </div>
                    </div>

                </Modal>
            </div>
        );
    }
}

TempUserLogin.propTypes = {
    isTempUserModalOpen: PropTypes.bool,
    token: PropTypes.string,

    // store actions
    closeTempUserModal: PropTypes.func,
    updateTempUser: PropTypes.func,
};

const mapStateToProps = state => ({
    message: state.users.loginMessage,
    token: state.users.token,
    isTempUserModalOpen: state.users.isTempUserModalOpen
});

// connecting redux state to the component props
export default connect(mapStateToProps, { closeTempUserModal, updateTempUser })(TempUserLogin);

// Hey! Are you sure you want to continue with \n the temporary account
// OR



// WEBPACK FOOTER //
// ./src/Components/Modals/TempUserLogin/TempUserLogin.js